import { Capitalize } from '../../Util/Strings/Capitalize'
import { TransformTranslate } from '../../Util/Transform/Transform'
import { HexMap } from '../../Data/HexMap/HexMap'
import { BuildHexMap } from '../../Data/HexMap/HexMapBuilder'
import { Music } from '../../Util/Music/Music'
import { Note } from '../../Data/HexMap/Note'
import { HxMapGroup } from '../HxMap/HxMapGroup'
import { Modes } from '../../Util/Music/Modes'
import './ModeHelper.scss'
import { Abbreviate } from '../../Util/Strings/Abbreviate'

export function ModeHelper(props:{width?:number, height?:number, selectedPosition?:number, radius?:number}){
    const radius:number = (props.radius) ? props.radius : 75
    const height:number = (props.height) ? props.height : 150
    const width:number = (props.width) ? props.width : 150
    const getChordType = (noteData:Note) => {
        let type:string = getChordTypeFull(noteData.params.noteIndex)
        return type.split('').splice(0,3).join('').toLowerCase()
    }
    const getChordTypeFull = (noteIndex:number) => {
        if([0,3,4].includes(noteIndex)){return 'Major'}
        if([1,2,5].includes(noteIndex)){return 'Minor'}
        return 'Diminished'        
    }
    let mapData:HexMap = BuildHexMap({columns:1, rows:1, tonic:Music.G, radius:radius})
    mapData.notes.forEach((note:Note)=>{
        const index:number = note.params.noteIndex
        const chordType:string = getChordType(note)
        const modeName:string = Abbreviate(Modes.Names[index],3)
        note.primaryLabel = Capitalize(modeName)
        note.secondaryLabel = String(index + 1)
        note.classNames.push(chordType)
    })


    return(
        <div className={'mode-helper'}>
            <svg width={width} height={height} className={'hex-parent mode-helper'}>
                <g transform={TransformTranslate(width/2,height/2)}>
                    <HxMapGroup hexMap={mapData}/>
                </g>
            </svg>
        </div>
    )
}